"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIntentSchema = exports.PromptContentSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const account_intent_slot_model_1 = require("./account-intent-slot.model");
const LexResourceNamePattern = /^([0-9a-zA-Z][_-]?)+$/;
exports.PromptContentSchema = yup_lib_1.default.object().shape({
    messages: yup_lib_1.default
        .array()
        .of(yup_lib_1.default
        .object()
        .shape({
        contentType: yup_lib_1.default.string().required(),
        content: yup_lib_1.default.string().required()
    })
        .required())
        .notRequired(),
    maxAttempts: yup_lib_1.default.number().integer().min(0).max(5).optional()
});
exports.AccountIntentSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required().label('Account'),
    locale: yup_lib_1.default.string().oneOf(data_1.localeCode).required().label('Locale'),
    name: yup_lib_1.default
        .string()
        .matches(LexResourceNamePattern, 'Please enter intent name consisting Alphabet, Number, _ & -')
        .required()
        .max(100, 'Must be maximum of 100 character')
        .label('Name'),
    description: yup_lib_1.default.string().optional().min(0).max(200).label('Description'),
    maxRetries: yup_lib_1.default.number().integer().required().min(0).max(5).label('Max Retries'),
    utterances: yup_lib_1.default.array().of(yup_lib_1.default.string().required()).notRequired().label('Utterance'),
    slots: yup_lib_1.default.array().of(account_intent_slot_model_1.AccountIntentSlotSchema).max(100).notRequired().label('Slots'),
    confirmationPrompt: exports.PromptContentSchema.notRequired().nullable().label('Confirmation Prompt'),
    rejectionStatement: exports.PromptContentSchema.notRequired().label('Rejection Statement'),
    conclusionStatement: exports.PromptContentSchema.notRequired().label('Conclusion Statement'),
    parentIntentSignature: yup_lib_1.default.string().min(1).notRequired().label('Parent Intent Signature'),
    disableMasking: yup_lib_1.default.boolean().optional().default(false).label('Disable Masking'),
    skipAnonymousPrompt: yup_lib_1.default.boolean().optional().default(false).label('Skip Anonymous Prompt')
});
